// like-unlike story
export const STORY_LIKE_INIT = "STORY_LIKE_INIT";
export const STORY_LIKE_SUCCESS = "STORY_LIKE_SUCCESS";
export const STORY_LIKE_FAILED = "STORY_LIKE_FAILED";